angular.module('dealerware.web.data').factory('DealerwareContractCollection', function ($http,Collection,DealerwareContractModel,$dealerwareSearchAliases, $mobilityCompanyAuthentication, DataUtils) {

    var baseEndpoint = '/locations/:location_id/reservations';

    function useSolrSearch (params) {
        return !('all' in params.filter);
    }

    'use strict';
    var collection = new Collection({
        baseEndpoint: baseEndpoint,
        model: 'DealerwareContractModel',
        customActions: {
            solr_search: {
                endpoint: '/locations/:location_id/reservations/search/',
                method: 'GET',
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultAssociationMapper: true,
                params: {
                    include_car: true,
                    include_customer: true,
                }
            },
            solr_search_with_filters: {
                endpoint: function (endpoint, args) {
                    return useSolrSearch (args.params) ? '/locations/:location_id/reservations/solr_search/full' : baseEndpoint;
                },
                method: 'GET',
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultAssociationMapper: true,
                params: {
                    include_car: true,
                    include_customer: true,
                }
            },
            customerContracts: {
                endpoint: '/locations/:location_id/customers/:id/reservations',
                method: 'GET',
                ignoreDefaultAssociationMapper: true
            },
            transactions: {
                endpoint: '/locations/:location_id/reports/transactions',
                rootNode: 'transaction_report_items',
                method: 'GET',
                ignoreDefaultAssociationMapper: true
            },
            contracts: {
                endpoint: '/locations/:location_id/reports/contracts',
                rootNode: 'contract_report_items',
                method: 'GET',
                ignoreDefaultAssociationMapper: true
            }
        },
        responseTransforms: {
            solr_search: mapSolrSearchResults,
            solr_search_with_filters: mapSolrSearchResults,
            transactions: mapTransactions,
            customerContracts: mapCustomerContracts
        }
    });

    function mapSolrSearchResults(args, data) {
        data.forEach(function(record) {
            record.data.effective_pickup_display = toLocalTime(record.data.actual_pickup || record.data.pickup);
            record.data.days_on_loan = Math.ceil(moment.utc().diff(moment.utc(record.data.actual_pickup), 'days', true)) || '';
        });
    }

    function mapTransactions(args, data) {
        data.forEach (function(record) {
            if (record.data.transaction_details) {
                [ 'type', 'state', 'total' ].forEach (function (type) {
                    record.data['transaction_' + type] = record.data.transaction_details[type]
                })
            }
            if (record.data.reservation_details) {
                [ 'id', 'dropoff_location', 'pickup_location' ].forEach (function (type) {
                    record.data[type] = record.data.reservation_details[type]
                })
            }
        });
    }

    function mapCustomerContracts(args, data) {
        data.forEach(function(record) {
            record.data.effective_pickup_display = toLocalTime(record.data.actual_pickup || record.data.pickup);
            record.data.effective_dropoff_display = toLocalTime(record.data.actual_dropoff || record.data.dropoff);
            record.data.days_on_loan = Math.ceil(moment.utc().diff(moment.utc(record.data.actual_pickup), 'days', true)) || '';
        });
    }

    function toLocalTime(timestamp) {
        return timestamp ? DataUtils.getInstance().formatTimestampSimple(timestamp, $mobilityCompanyAuthentication.location.time_zone_name) : undefined;
    }

    jQuery.extend(collection.prototype,{
        toSummaryString: function() {
            return this.pagination && isObject(this.pagination) && this.pagination.total >= 0 ? 'Contracts: ' + this.pagination.total : '';
        }
    });

    return collection;
});